import CustomCheckbox from 'designer/component/element/Checkbox'
import { getCheckValue } from 'designer/component/action/Data'

const CheckboxControl = (props) => {
  const { uischema, handleChange, path, config } = props
  const data = config?.jsonData

  let valueChecked = getCheckValue(uischema.valueChecked)
  let valueUnchecked = getCheckValue(uischema.valueUnchecked)

  const updateData = async (checked) => {
    let value = checked ? valueChecked : valueUnchecked
    handleChange(path, value)
  }

  return (
    <CustomCheckbox
      {...props}
      uischema={uischema}
      value={data}
      updateData={updateData}
    />
  )
}

export default CheckboxControl
